import FacillityNew from './FacillityNew'

export default FacillityNew;